import React from 'react';
import { CalendarClock, Filter, Mail, Users } from 'lucide-react';

const paris = (iso) => new Date(iso).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', dateStyle: 'full', timeStyle: 'short' });

export const ApercuGroupe = ({ c, id, exclus, setExclus, modifiable }) => {
  const dests = c.destinataires || [];
  const basculer = (mid) => setExclus((l) => (l.includes(mid) ? l.filter((x) => x !== mid) : [...l, mid]));
  const nb = dests.length - exclus.length;
  return (
    <div className="mt-2 space-y-2 rounded-lg border border-slate-200 bg-white p-2.5 text-xs text-slate-700" data-testid={`klarys-groupe-${id}`}>
      <p className="flex items-center gap-1.5 font-semibold text-slate-800">
        <Users className="h-3.5 w-3.5 text-[#0a3d62]" />
        <span data-testid={`klarys-groupe-compteur-${id}`}>{nb} / {dests.length} destinataire(s)</span>
        <span className="font-normal text-slate-500">— {c.format?.toUpperCase()} personnalisé, sous-dossier « {c.sous_dossier} », non visible dans l'espace membre</span>
      </p>
      {c.critere && (
        <div className="rounded border border-sky-100 bg-sky-50 px-2 py-1.5 text-sky-900" data-testid={`klarys-groupe-critere-${id}`}>
          <p className="flex items-center gap-1.5"><Filter className="h-3.5 w-3.5" /> Critère : <b>{c.critere.critere_label}</b></p>
          <p className="mt-0.5 text-[11px] text-sky-800">{c.critere.total_trouves} membre(s) trouvé(s) dans les données{c.critere.nb_lots > 1 ? ` — lot ${c.critere.lot} / ${c.critere.nb_lots}` : ''}</p>
          {c.critere.ignores?.length > 0 && (
            <p className="mt-0.5 text-[11px] text-amber-800" data-testid={`klarys-groupe-ignores-${id}`}>Non inclus : {c.critere.ignores.join(' ; ')}</p>
          )}
        </div>
      )}
      {c.programme_le && (
        <p className="flex items-center gap-1.5 rounded border border-violet-100 bg-violet-50 px-2 py-1.5 text-violet-900" data-testid={`klarys-groupe-programme-${id}`}>
          <CalendarClock className="h-3.5 w-3.5" /> Envoi programmé le <b>{paris(c.programme_le)}</b> (heure de Paris) — documents générés à ce moment avec les données à jour
        </p>
      )}
      <div className="max-h-48 overflow-y-auto rounded border border-slate-100">
        {dests.map((d, i) => (
          <label key={d.membre_id} className={`flex cursor-pointer items-center gap-2 border-b border-slate-100 px-2 py-1.5 last:border-0 ${exclus.includes(d.membre_id) ? 'opacity-50' : ''}`}
            data-testid={`klarys-groupe-dest-${id}-${i}`}>
            <input type="checkbox" checked={!exclus.includes(d.membre_id)} disabled={!modifiable} onChange={() => basculer(d.membre_id)}
              className="h-3.5 w-3.5 accent-[#0a3d62]" data-testid={`klarys-groupe-check-${id}-${i}`} />
            <span className="min-w-0 flex-1 truncate font-medium text-slate-800">{d.membre_nom}{d.numero_membre ? ` (${d.numero_membre})` : ''}</span>
            <span className="truncate text-slate-500">{d.email}</span>
            {!d.email_fiche && <span className="rounded bg-amber-100 px-1 text-[10px] font-semibold text-amber-800">autre adresse</span>}
          </label>
        ))}
      </div>
      {c.apercu && (
        <div className="border-t border-slate-100 pt-2" data-testid={`klarys-groupe-apercu-${id}`}>
          <p className="flex items-center gap-1.5 text-slate-500"><Mail className="h-3.5 w-3.5 text-[#0a3d62]" /> Aperçu de l'e-mail pour {c.apercu.membre_nom}</p>
          <p className="mt-1">Objet : <b data-testid={`klarys-groupe-objet-${id}`}>{c.apercu.objet}</b></p>
          <p className="mt-1.5 max-h-48 overflow-y-auto whitespace-pre-wrap rounded bg-slate-50 p-2 text-slate-800" data-testid={`klarys-groupe-message-${id}`}>{c.apercu.message}</p>
          <p className="mt-1 text-slate-500">Chaque membre reçoit son propre document en pièce jointe.</p>
        </div>
      )}
    </div>
  );
};
